var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35987_33144)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M57.336 0H22.66C9.10401 0 0 9.51201 0 23.668V56.3361C0 70.4881 9.10401 80.0001 22.66 80.0001H57.332C70.888 80.0001 80 70.4881 80 56.3361V23.668C80 9.51201 70.892 0 57.336 0Z",
    fill: "#CE2600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6594 33.9585H49.6017C46.3172 33.9643 43.6565 36.5586 43.6505 39.761C43.646 42.9705 46.3099 45.5763 49.6017 45.5807H56.6654V46.0905C56.6654 51.6893 53.2714 55 47.5275 55H32.4713C26.7261 55 23.332 51.6893 23.332 46.0905V33.8964C23.332 28.2977 26.7261 25 32.4713 25H47.5217C53.2654 25 56.6594 28.2977 56.6594 33.8964V33.9585ZM31.2313 33.9455H40.6314H40.6372H40.649C41.3527 33.9426 41.9217 33.3836 41.9187 32.6961C41.9157 32.01 41.3409 31.4553 40.6372 31.4582H31.2313C30.532 31.4611 29.9646 32.0143 29.9617 32.6975C29.9587 33.3836 30.5276 33.9426 31.2313 33.9455Z",
    fill: "#CE2600"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M46.7303 40.4945C47.0788 42.0798 48.4688 43.1952 50.0556 43.1662H55.4721C56.1325 43.1662 56.668 42.6193 56.668 41.9433V37.7242C56.6665 37.0497 56.1325 36.5014 55.4721 36.5H49.9281C48.1231 36.5058 46.6651 38.004 46.668 39.8505C46.668 40.0665 46.6893 40.2827 46.7303 40.4945Z",
    fill: "#CE2600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9987 41.4974C50.9192 41.4974 51.6654 40.7512 51.6654 39.8307C51.6654 38.9103 50.9192 38.1641 49.9987 38.1641C49.0782 38.1641 48.332 38.9103 48.332 39.8307C48.332 40.7512 49.0782 41.4974 49.9987 41.4974Z",
    fill: "#CE2600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35987_33144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCard);
export default __webpack_public_path__ + "static/media/bank-card.c2e4881e1b94554af0e4195b16f9a1b8.svg";
export { ForwardRef as ReactComponent };